import { combineReducers } from 'redux';
import LoginReducer from '../Container/Login/LoginReducer';

export default combineReducers({
    LoginReducer,
});